import { t } from "i18next";

import { colors } from "#app/theme/v1/colors";
import { getFeatureDisplay } from "#modules/quoteRequestLines/views/DetailsPanel/ProcessSteps/Features/getFeatureDisplay";
import { Icon, IconName } from "#shared/icons/Icon";
import { Flex } from "#shared/view/components/Flex";
import { Text } from "#shared/view/components/Text";
import { FormatedFeatureType, formatSingularOrPlural } from "shared";

type Props = {
  feature: FormatedFeatureType;
  icon: IconName;
};

const FEATURE_LINE_HEIGHT = 20;

export const Feature = ({ feature, icon }: Props) => {
  const { labelKey, properties } = getFeatureDisplay(feature);
  const featureLabel = formatSingularOrPlural(feature.count, t(labelKey), {
    isValueVisible: false,
  });

  const propertiesDisplay = properties.length > 0 ? `${properties.join(", ")}` : "";

  const featureDisplay = `${featureLabel} ${propertiesDisplay}`;

  return (
    <Flex gap="xs" align="flex-start">
      <Flex h={FEATURE_LINE_HEIGHT}>
        <Icon name={icon} size={16} />
      </Flex>

      <Text component="span">
        <Text component="span" fw={600} c={colors.violet[5]}>
          {feature.count}
        </Text>{" "}
        <Text component="span">{featureDisplay}</Text>
      </Text>
    </Flex>
  );
};
